<script setup lang="ts">
import type { MenuItem } from '@global-types/nav/menuItem';
import { computed } from 'vue';
import Typography from '@components/Typography.vue';
import { useNavbarMenu } from '../useNavbarMenu';

interface SidebarSubmenuProps {
  isOpen?: boolean;
  submenus: MenuItem[];
  isProfileManagement: boolean;
  hasKycActive?: boolean;
  hasPayBuyer?: boolean;
}

const props = withDefaults(defineProps<SidebarSubmenuProps>(), {
  isOpen: false,
  submenus: () => [],
  isProfileManagement: false,
  hasKycActive: false,
  hasPayBuyer: false,
});

const {
  isCurrentPage,
} = useNavbarMenu();

const displayedSubmenus = computed<MenuItem[]>(() => props.submenus.filter((submenu: MenuItem) => (
  (!submenu.isProfileManagement || props.isProfileManagement)
    && (!submenu.hasKycActive || props.hasKycActive)
    && (!submenu.requiresPayBuyer || props.hasPayBuyer)
)));
</script>

<template>
  <ul
    class="side-bar-submenu__list"
    :class="{ open: isOpen }"
  >
    <li
      v-for="submenu in displayedSubmenus"
      :key="submenu.name"
      class="side-bar-submenu__item"
      :class="{ 'side-bar-menu--current-page': isCurrentPage(submenu.link) }"
    >
      <a :href="submenu.link" class="side-bar-submenu__link">
        <Typography :variant="isCurrentPage(submenu.link) ? 'body-small-bold' : 'body-small'">
          {{ submenu.name }}
        </Typography>
      </a>
    </li>
  </ul>
</template>
